var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPublication = function SvgPublication(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_357_4377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 10.5991V11.4018C4 11.7324 4.26803 12.0004 4.59867 12.0004H11.4013C11.732 12.0004 12 11.7324 12 11.4018V10.5991C12 10.2685 11.732 10.0004 11.4013 10.0004H4.59867C4.26803 10.0004 4 10.2685 4 10.5991Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6.59842V7.40109C4 7.73172 4.26803 7.99976 4.59867 7.99976L11.4013 7.99976C11.732 7.99976 12 7.73172 12 7.40109V6.59842C12 6.26779 11.732 5.99976 11.4013 5.99976H4.59867C4.26803 5.99976 4 6.26779 4 6.59842Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 2.46012L13.5405 2.00039L11.8827 0.342522C11.6633 0.123189 11.366 0.000122096 11.0559 0.000122096H1.1692C0.523467 -1.12376e-05 0 0.523456 0 1.16919V14.8308C0 15.4765 0.523467 16 1.1692 16H14.8308C15.4765 16 16 15.4765 16 14.8308V4.94412C16 4.63399 15.8768 4.33666 15.6576 4.11732L14.0004 2.46012H14.0003ZM14.0003 14.0004H2.00027V2.00026H10.7123L14.0003 5.28826V14.0003V14.0004Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_357_4377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPublication, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/publication.ee9fe6df.svg";
export { ForwardRef as ReactComponent };